export const Majors = [
  { value: "UD", text: 'دیپلم' },
  { value: "BA", text: 'فوق لیسانس' },
  { value: "MA", text: 'لیسانس' },
  { value: "PH", text: 'دکترا' },
  { value: "PD", text: 'فوق دکترا' },



]

const MajorSetter = (val) => {

  let value = null
  Majors.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default MajorSetter;
